var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state.active)?_c('div',{staticClass:"app-loader"},[_vm._m(0),_c('div',{staticClass:"loader-message"},[_vm._v(_vm._s(_vm.state.message || 'Loading...'))])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orbit-spinner"},[_c('div',{staticClass:"orbit"}),_c('div',{staticClass:"orbit"}),_c('div',{staticClass:"orbit"})])
}]

export { render, staticRenderFns }